<app-loader></app-loader>
<app-header class="fixed-top"></app-header>
<div class="main">
  <router-outlet></router-outlet>
</div>
<!-- <app-home></app-home> -->
<app-footer></app-footer>
